import React, { useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"


const Tags = (props) => {

    const [allTagsList, setAllTagsList] = useState([]);
    const [eventTagsList, setEventTagsList] = useState([]);
    const [tagToRemove, setTagToRemove] = useState();
    const [addTagModal, setAddTagModal] = useState(false);
    const [textBox, setTextBox] = useState("");

    

    useEffect(() => {
      apiGet(`intraneteventtags/getalleventtags`).then(res => {
            res.json().then(data => {
              setAllTagsList(data)
            })
        })
        apiGet(`intraneteventtags/gettagsbyevent?eventid=${props.eventId}`).then(res => {
            res.json().then(data => {
              setEventTagsList(data)
            })
        })
      }, [])

    const addTagToEvent = (tag_id) => {
      apiPut(`intraneteventtags/linktagwithevent`, {tag_id: tag_id, event_id: props.eventId}).then(response => {
            if(response.ok){
              apiGet(`intraneteventtags/gettagsbyevent?eventid=${props.eventId}`).then(res => {
                    res.json().then(data => {
                      setEventTagsList(data)
                    })
                })
            }
        })
    }

    const createTag = () => {
        if (textBox){
          apiPut(`intraneteventtags/addeventtag`, {tag: textBox})
            .then(response => {
              if(response.ok){
                response.json().then(data => {
                    addTagToEvent(data[0].id)
                })
                apiGet(`intraneteventtags/getalleventtags`).then(res => {
                  res.json().then(data => {
                    setAllTagsList(data)
                  })
                })
              }
            })
        }
    }

    const removeTagConfirmed = () => {
      apiDelete(`intraneteventtags/removetagfromevent`, {tag_id: tagToRemove, event_id: props.eventId}).then(response => {
            if(response.ok){
                setTagToRemove(null)
                apiGet(`intraneteventtags/gettagsbyevent?eventid=${props.eventId}`).then(res => {
                    res.json().then(data => {
                      setEventTagsList(data)
                    })
                })
            }
        })
    }

    return (
        <>
        <div className="section">
            <Row>
                <Col md={10}>
                    <h4>Tags</h4>
                </Col>
                <Col md={2}>
                    <Button onClick={() => setAddTagModal(true)}>Add Tags</Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    {eventTagsList.map(tag => {
                        return <span className="tag">{tag.tag} <span onClick={() => setTagToRemove(tag.tagid)}>X</span></span>
                    })}
                </Col>
            </Row>
            
            
        </div>
        <Modal  show={tagToRemove} onHide={() => setTagToRemove(null)}>
              <Modal.Header closeButton>
                <Modal.Title>Tag Removal</Modal.Title>
              </Modal.Header>
              <Modal.Body>Are You Sure you want to Remove this tag?</Modal.Body>
              <Modal.Footer>
              <Button variant="primary" onClick={removeTagConfirmed}>
                  Yes
                </Button>
                <Button variant="secondary" onClick={() => setTagToRemove(null)}>
                  No
                </Button>
                
              </Modal.Footer>
            </Modal>
        <Modal  show={addTagModal} onHide={() => setAddTagModal(false)}>
              <Modal.Header closeButton>
                  <Modal.Title>Add Tags</Modal.Title>
                
                
              </Modal.Header>
              <Modal.Body>
              <Row>
                    <Col>
                        <Form.Control onChange={(event) => setTextBox(event.target.value)} type="text" value={textBox} />
                    </Col>
                    <Col>
                        <Button onClick={createTag}>Create New Tag</Button>
                    </Col>
                </Row>
                <Row>
                {allTagsList.map(tag => {
                    if(!textBox || tag.tag.toLowerCase().includes(textBox.toLowerCase())){
                    return <span onClick={() => addTagToEvent(tag.id)} className="tag">{tag.tag}</span>
                    }
                })}
                </Row>
              </Modal.Body>
              <Modal.Footer>
               
                <Button variant="secondary" onClick={() => setAddTagModal(false)}>
                  Exit
                </Button>
                
              </Modal.Footer>
            </Modal>
        </>
    )
}

export default Tags;